/**
 * Touch时修改opacity组件
 * author: wangbo16
 */
import React from 'react';
import './index.scss';

// TODO 优化：不用div包裹
const TouchOpacity = (WrappedComponent) => {
  const handleTouchStart = (e, disable) => {
    if (disable) return;
    e.target.style.opacity = 0.5;
  };
  const handleTouchEnd = (e, disable) => {
    if (disable) return;
    e.target.style.opacity = 1;
  };
  return (props) => {
    const { disable } = props;
    return (
      <div
        onTouchStart={(e) => handleTouchStart(e, disable)}
        onTouchEnd={(e) => handleTouchEnd(e, disable)}
        onTouchCancel={(e) => handleTouchEnd(e, disable)}
        className="touch-wrapper"
      >
        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default TouchOpacity;
